const TIME_ZONE = 'America/Monterrey';

/** Mexican statutory holidays that skip a business day (same rules as ruido-delivery-estimate.js). */
const isHoliday = (date) => {
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  const weekday = date.getUTCDay();
  return (month === 1 && day === 1) || (month === 2 && weekday === 1 && day <= 7)
    || (month === 3 && weekday === 1 && day >= 15 && day <= 21)
    || (month === 5 && day === 1) || (month === 9 && day === 16)
    || (month === 11 && weekday === 1 && day >= 15 && day <= 21)
    || (month === 12 && day === 25);
};

const nowInStore = () => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  }).formatToParts(new Date());
  return Object.fromEntries(parts.map(({ type, value }) => [type, Number(value)]));
};

class RuidoArrival extends HTMLElement {
  connectedCallback() {
    this.render();
    this.timer = setInterval(() => this.render(), 30000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  render() {
    const now = nowInStore();
    const date = new Date(Date.UTC(now.year, now.month - 1, now.day));
    let remaining = Number(this.dataset.days) || 3;
    while (remaining > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !isHoliday(date)) remaining--;
    }

    const label = new Intl.DateTimeFormat('es-MX', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' })
      .format(date)
      .replace(',', '');
    const dateNode = this.querySelector('[data-arrival-date]');
    if (dateNode && dateNode.textContent !== label) dateNode.textContent = label;

    const secondsLeft = 86400 - (now.hour * 3600 + now.minute * 60 + now.second);
    const hours = Math.floor(secondsLeft / 3600);
    const minutes = Math.floor((secondsLeft % 3600) / 60);
    const timer = this.querySelector('[data-arrival-timer]');
    if (timer) timer.textContent = hours > 0 ? `${hours} h ${minutes} min` : `${minutes} min`;
    this.querySelector('[data-arrival-timer-wrap]')?.removeAttribute('hidden');
  }
}

if (!customElements.get('ruido-arrival')) customElements.define('ruido-arrival', RuidoArrival);
